<template>
  <div>
    <confirm-box :dialog="dialog" @confirmed="deletePatient" @cancel="cancel" />
    <v-data-table
      :headers="tbHeaders"
      :items="referPresumptiveData"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th v-for="header in headers" :key="header.text" class="header--text">
              <span v-if="header.value">{{ header.text }}</span>
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.dob }}</td>
          <td>{{ item.sex==1?"Male":"Female" }}</td>
          <td>{{ item.volunteer?item.volunteer.code:"" }} ({{ item.volunteer?item.volunteer.name:"" }})</td>
          <td>{{ item.referral_date }}</td>
          <td>{{ item.case_found_at_name.name }}</td>
          <td>
            <span v-if="item.confirm==1">Presumptive</span>
            <span v-if="item.confirm==0">Refer</span>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination color="purple accent-4" v-model="page" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>

<script>
import ConfirmBox from "@/components/notification/ConfirmBox";

import { mapState } from "vuex";
export default {
  components: {
    ConfirmBox
  },
  data: () => ({
    item: {},
    dialog: false,
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    tbHeaders: [
      { text: "No", value: "no" },
      { text: "Name", value: "name" },
      { text: "DOB", value: "dob" },
      { text: "Sex", value: "sex" },
      { text: "Volunteer", value: "volunteer" },
      { text: "Referral Date", value: "referral_date" },
      { text: "Case Found At", value: "case_found_at" },
      { text: "Status", value: "status" }
    ]
  }),
  computed: {
    ...mapState("PresumptiveRefer", ["referPresumptiveData"])
  },
  methods: {
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deletePatient() {
      let data = {
        id: this.item.id
      };
      this.$store
        .dispatch("PresumptiveRefer/deleteReferPatient", data)
        .then(() => (this.dialog = !this.dialog));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    goUpdateForm(item) {
      this.$router.push(
        `/presumptive-referral/edit/${item.id}/${item.township_id}`
      );
    },

    goToPresumptive(item) {
      if (item.confirm == 0)
        this.$router.push(`/save-as-presumptive/${item.id}/REFERRAL`);
      else this.$router.push(`/presumptive-detail/${item.id}`);
    }
  }
};
</script>

<style>
</style>